var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogined = function SvgLogined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Logined_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h20v20H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Logined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.91 5.41c0-1.61-1.3-2.91-2.91-2.91-1.62 0-2.92 1.3-2.92 2.91S8.38 8.33 10 8.33c1.61 0 2.91-1.31 2.91-2.92M2.5 17.5h15V17c0-1.87 0-2.81-.37-3.52-.32-.63-.83-1.14-1.45-1.46-.72-.36-1.65-.36-3.52-.36H7.83c-1.87 0-2.8 0-3.52.36-.62.32-1.13.83-1.45 1.46-.36.71-.36 1.65-.36 3.52z"
  }))));
};
export default SvgLogined;